/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// Old AMD key: `ac/spa-context`

// TODO: we will improve the type later when we know the code better.
type ApiType = {
	navigate?: (url: string, goTo?: () => void) => void;
};

let containerApi: ApiType | null = null;
let navigationApi: ApiType | null = null;

export const provideContainerApi = (api: ApiType): void => {
	containerApi = api;
};

export const provideNavigationApi = (api: ApiType): void => {
	navigationApi = api;
};

export const isInIframe = (): boolean => containerApi !== null;

export const canSpaTransition = (): boolean => navigationApi !== null;

export const getContainerApi = (): ApiType | null => containerApi;

export const getNavigationApi = (): ApiType | null => navigationApi;

export const resetSpaContext = (): void => {
	containerApi = null;
	navigationApi = null;
};
